module.exports = __webpack_public_path__ + "img/pink.c3e654bb.png";